(function () {
  var configEl = document.getElementById("herhe-subscriber-pricing-config");
  if (!configEl) return;

  var config;
  try {
    config = JSON.parse(configEl.textContent || "{}");
  } catch (error) {
    return;
  }

  function formatMoney(cents, withCurrency) {
    var format = withCurrency
      ? config.moneyWithCurrencyFormat
      : config.moneyFormat;
    if (!format) {
      return (cents / 100).toFixed(2);
    }

    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = String(Math.round(cents / 100));

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function subscriberCents(priceCents) {
    var percent = Number(config.percent || 0);
    if (!percent) return priceCents;
    return Math.round((priceCents * (100 - percent)) / 100);
  }

  function renderPriceHtml(priceCents, compareAtCents, options) {
    options = options || {};
    var withCurrency = !!options.withCurrency;
    var showBadge = options.showBadge !== false;
    var wrapperClass = options.wrapperClass || "";

    if (!config.eligible || !priceCents) {
      if (compareAtCents && compareAtCents > priceCents) {
        return (
          '<span class="pdp-price pdp-price--compare">' +
          formatMoney(compareAtCents, withCurrency) +
          "</span>" +
          '<span class="pdp-price pdp-price--sale">' +
          formatMoney(priceCents, withCurrency) +
          "</span>"
        );
      }

      return (
        '<span class="pdp-price">' +
        formatMoney(priceCents, withCurrency) +
        "</span>"
      );
    }

    var discounted = subscriberCents(priceCents);
    var html =
      '<span class="herhe-subscriber-price ' +
      wrapperClass +
      '" data-herhe-price-cents="' +
      priceCents +
      '" data-herhe-subscriber-cents="' +
      discounted +
      '">' +
      '<span class="herhe-subscriber-price__compare">' +
      formatMoney(priceCents, withCurrency) +
      "</span>" +
      '<span class="herhe-subscriber-price__amount">' +
      formatMoney(discounted, withCurrency) +
      "</span>";

    if (showBadge) {
      html +=
        '<span class="herhe-subscriber-price__badge">' +
        (config.badgeLabel || "Member price") +
        "</span>";
    }

    html += "</span>";
    return html;
  }

  function updateCartTotals() {
    if (!config.eligible) return;

    document.querySelectorAll("[data-herhe-cart-subtotal-cents]").forEach(function (node) {
      var subtotalCents = Number(node.getAttribute("data-herhe-cart-subtotal-cents") || 0);
      if (!subtotalCents) return;

      var discounted = subscriberCents(subtotalCents);
      var totalValue = node.querySelector(".herhe-subscriber-price__amount");
      if (totalValue) {
        totalValue.textContent = formatMoney(discounted, !!node.dataset.herheUseCurrency);
      }
    });

    document.querySelectorAll("[data-herhe-cart-discount-cents]").forEach(function (node) {
      var discountCents = Number(node.getAttribute("data-herhe-cart-discount-cents") || 0);
      node.textContent = "-" + formatMoney(discountCents, !!node.dataset.herheUseCurrency);
    });
  }

  window.HerheSubscriberPricing = {
    config: config,
    formatMoney: formatMoney,
    subscriberCents: subscriberCents,
    renderPriceHtml: renderPriceHtml,
    updateCartTotals: updateCartTotals,
  };

  document.addEventListener("cart:update", updateCartTotals);
  document.addEventListener("DOMContentLoaded", updateCartTotals);
  updateCartTotals();
})();
